import { SetBasketModel } from 'pmg-services';
import { services } from '../services';

const basketStore = {
  state: {
    basket: undefined,
    clubExtrasAvailable: false, // don't call this  without doing the dispatch checkIfClubExtrasAvailable
    donation: {
      bundleId: 0,
      clubId: 0,
      amount: 0,
    },
    lateReferral: {
      referrerIdentifier: '',
      isVerified: false,
      referrerName: '',
    },
    selectedProfessional: null,
    selectedLessonBundle: null,
  },

  getters: {
    getBasket: state => state.basket,
  },

  mutations: {
    setCharityDonation(state, amount) {
      state.donation = {
        bundleId: state.basket.BundleId,
        clubId: state.basket.NewClubId,
        amount,
      };
    },

    emptyCharityDonation(state) {
      state.donation = {
        bundleId: 0,
        clubId: 0,
        amount: 0,
      };
    },

    pushBasket(state, basket) {
      // Auto-select mandatory extras if not already selected
      let updatedBasket = basket;
      if (basket && basket.AdditionalExtras) {
        updatedBasket = {
          ...basket,
          AdditionalExtras: basket.AdditionalExtras.map((extra) => {
            if (extra.IsMandatory && !extra.Selected) {
              return { ...extra, Selected: true };
            }
            return extra;
          }),
        };
      }

      state.basket = updatedBasket;

      if (basket === null || basket.NewClubId !== state.donation.clubId || basket.BundleId !== state.donation.bundleId) {
        state.donation = {
          bundleId: 0,
          clubId: 0,
          amount: 0,
        };
      }
    },

    setClubExtrasAvailable(state, available) {
      state.clubExtrasAvailable = available;
    },

    setLateReferral(state, { referrerIdentifier, isVerified, referrerName }) {
      state.lateReferral = {
        referrerIdentifier,
        isVerified,
        referrerName,
      };
    },

    clearLateReferral(state) {
      state.lateReferral = {
        referrerIdentifier: '',
        isVerified: false,
        referrerName: '',
      };
    },

    setSelectedProfessional(state, professional) {
      state.selectedProfessional = professional;
    },

    setSelectedLessonBundle(state, lessonBundle) {
      state.selectedLessonBundle = lessonBundle;
    },
  },

  actions: {
    setCharityDonation(context, amount) {
      context.commit('setCharityDonation', amount);
    },

    emptyCharityDonation(context) {
      context.commit('emptyCharityDonation');
    },

    async setBasketBundle(context, bundle) {
      return new Promise((resolve) => {
        context.commit('setRefreshingBasket', true, { root: true });
        if (bundle.preserveCharity === undefined || bundle.preserveCharity !== true) {
          context.commit('emptyCharityDonation');
        }

        // Ensure mandatory extras are always included
        let updatedBundle = bundle;
        if (context.state.basket && context.state.basket.AdditionalExtras) {
          const mandatoryExtraIds = context.state.basket.AdditionalExtras
            .filter(x => x.IsMandatory)
            .map(x => x.Id);

          if (bundle.AdditionalExtrasIds) {
            // Add mandatory extras if not already in the list
            mandatoryExtraIds.forEach((id) => {
              if (!bundle.AdditionalExtrasIds.includes(id)) {
                bundle.AdditionalExtrasIds.push(id);
              }
            });
            updatedBundle = { ...bundle, AdditionalExtrasIds: bundle.AdditionalExtrasIds };
          } else {
            updatedBundle = { ...bundle, AdditionalExtrasIds: mandatoryExtraIds };
          }
        }

        const professionalId = context.state.selectedProfessional
          ? context.state.selectedProfessional.Id
          : null;

        services.checkout
          .setBasket(
            updatedBundle.BundleId,
            updatedBundle.PromoCode,
            updatedBundle.NewClubId,
            updatedBundle.AdditionalBundleIds,
            null,
            updatedBundle.AdditionalExtrasIds,
            professionalId,
          )
          .then(() => {
            services.checkout.getBasket(null, true).then((basket) => {
              context.commit('pushBasket', basket);
              context.commit('setRefreshingBasket', false, { root: true });

              resolve();
            });
          })
          .catch((error) => {
            context.commit('setRefreshingBasket', false, { root: true });
            console.error('Failed to update basket:', error);
            context.dispatch('refreshBasket');
            resolve();
          });
      });
    },

    async toggleExtraInBasket(context, payload) {
      // Prevent toggling mandatory extras
      const extra = context.state.basket.AdditionalExtras.find(x => x.Id === payload.id);
      if (extra && extra.IsMandatory) {
        return; // Don't allow deselecting mandatory extras
      }

      let selectedIds = [...context.state.basket.AdditionalExtras.filter(x => x.Selected === true)
        .map(x => x.Id)];
      const exists = selectedIds.filter(x => x === payload.id);

      if (exists.length > 0) {
        selectedIds = [...selectedIds.filter(x => x !== payload.id)];
        // eslint-disable-next-line no-param-reassign
        if (payload.skipBackend) context.state.basket.AdditionalExtras.filter(x => x.Id === payload.id)[0].Selected = false;
      } else {
        selectedIds.push(payload.id);
        // eslint-disable-next-line no-param-reassign
        if (payload.skipBackend) context.state.basket.AdditionalExtras.filter(x => x.Id === payload.id)[0].Selected = true;
      }


      const selectedAddons = [...context.state.basket.AdditionalItems.filter(x => x.Selected === true).map(x => x.Id)];
      if (context.state.selectedLessonBundle) {
        selectedAddons.push(context.state.selectedLessonBundle.BundleId);
      }
      const bundle = new SetBasketModel(context.state.basket.BundleId, context.state.basket.PromoCode, context.state.basket.NewClubId, null, selectedAddons, selectedIds);
      // bad
      bundle.preserveCharity = true;

      if (payload.skipBackend === undefined || !payload.skipBackend) { await context.dispatch('setBasketBundle', bundle); }
    },

    async toggleAddOnInBasket(context, id) {
      let selectedIds = [...context.state.basket.AdditionalItems.filter(x => x.Selected === true)
        .map(x => x.Id)];

      const exists = [...selectedIds.filter(x => x === id)];
      if (exists.length > 0) {
        selectedIds = [];
      } else {
        selectedIds = [id];
      }

      if (context.state.basket && context.state.basket.AdditionalItems) {
        context.state.basket.AdditionalItems.forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          item.Selected = selectedIds.includes(item.Id);
        });
      }

      if (context.state.selectedLessonBundle) {
        selectedIds.push(context.state.selectedLessonBundle.BundleId);
      }

      const selectedExtras = [...context.state.basket.AdditionalExtras.filter(x => x.Selected === true).map(x => x.Id)];
      const bundle = new SetBasketModel(context.state.basket.BundleId, context.state.basket.PromoCode, context.state.basket.NewClubId, null, selectedIds, selectedExtras);
      // bad
      bundle.preserveCharity = true;

      await context.dispatch('setBasketBundle', bundle);
    },

    async togglePromoCodeInBasket(context, promoCode) {
      const selectedIds = [...context.state.basket.AdditionalItems.filter(x => x.Selected === true).map(x => x.Id)];
      if (context.state.selectedLessonBundle) {
        selectedIds.push(context.state.selectedLessonBundle.BundleId);
      }
      const selectedExtras = [...context.state.basket.AdditionalExtras.filter(x => x.Selected === true).map(x => x.Id)];

      const bundle = new SetBasketModel(context.state.basket.BundleId, promoCode, context.state.basket.NewClubId, null, selectedIds, selectedExtras);
      // bad
      bundle.preserveCharity = true;

      await context.dispatch('setBasketBundle', bundle);
    },

    async toggleLessonBundle(context, lessonPackage) {
      const currentBundle = context.state.selectedLessonBundle;
      const isSelected = currentBundle && currentBundle.BundleId === lessonPackage.BundleId;

      context.commit('setSelectedLessonBundle', isSelected ? null : lessonPackage);

      if (isSelected) {
        context.commit('setSelectedProfessional', null);
      }

      let selectedAddOns = [...context.state.basket.AdditionalItems.filter(x => x.Selected === true).map(x => x.Id)];
      if (isSelected) {
        selectedAddOns = selectedAddOns.filter(id => id !== lessonPackage.BundleId);
      } else if (!selectedAddOns.includes(lessonPackage.BundleId)) {
        selectedAddOns.push(lessonPackage.BundleId);
      }

      const selectedExtras = [...context.state.basket.AdditionalExtras.filter(x => x.Selected === true).map(x => x.Id)];
      const bundle = new SetBasketModel(
        context.state.basket.BundleId,
        context.state.basket.PromoCode,
        context.state.basket.NewClubId,
        null,
        selectedAddOns,
        selectedExtras,
      );
      bundle.preserveCharity = true;

      await context.dispatch('setBasketBundle', bundle);
    },

    async setLateReferral(context, { referrerIdentifier, isVerified, referrerName }) {
      context.commit('setLateReferral', { referrerIdentifier, isVerified, referrerName });
    },

    async clearLateReferral(context) {
      context.commit('clearLateReferral');
    },

    async selectProfessional(context, professional) {
      context.commit('setSelectedProfessional', professional);

      const selectedAddOns = [...context.state.basket.AdditionalItems.filter(x => x.Selected === true).map(x => x.Id)];
      if (context.state.selectedLessonBundle) {
        selectedAddOns.push(context.state.selectedLessonBundle.BundleId);
      }
      const selectedExtras = [...context.state.basket.AdditionalExtras.filter(x => x.Selected === true).map(x => x.Id)];
      const bundle = new SetBasketModel(
        context.state.basket.BundleId,
        context.state.basket.PromoCode,
        context.state.basket.NewClubId,
        null,
        selectedAddOns,
        selectedExtras,
      );
      bundle.preserveCharity = true;

      await context.dispatch('setBasketBundle', bundle);
    },

    async clearProfessional(context) {
      context.commit('setSelectedProfessional', null);

      const selectedAddOns = [...context.state.basket.AdditionalItems.filter(x => x.Selected === true).map(x => x.Id)];
      if (context.state.selectedLessonBundle) {
        selectedAddOns.push(context.state.selectedLessonBundle.BundleId);
      }
      const selectedExtras = [...context.state.basket.AdditionalExtras.filter(x => x.Selected === true).map(x => x.Id)];
      const bundle = new SetBasketModel(
        context.state.basket.BundleId,
        context.state.basket.PromoCode,
        context.state.basket.NewClubId,
        null,
        selectedAddOns,
        selectedExtras,
      );
      bundle.preserveCharity = true;

      await context.dispatch('setBasketBundle', bundle);
    },

    refreshBasket(context) {
      return new Promise((resolve) => {
        context.commit('setRefreshingBasket', true, { root: true });
        services.checkout.getBasket(null, true).then((basket) => {
          context.commit('pushBasket', basket);
          context.commit('setRefreshingBasket', false, { root: true });
          resolve();
        });
      });
    },

    emptyBasket(context) {
      return new Promise((resolve) => {
        context.commit('setRefreshingBasket', true, { root: true });
        context.commit('clearLateReferral');
        context.commit('setSelectedProfessional', null);
        context.commit('setSelectedLessonBundle', null);
        services.checkout.emptyBasket().then(() => {
          services.checkout.getBasket(null, true).then((basket) => {
            context.commit('pushBasket', basket);
            context.commit('setRefreshingBasket', false, { root: true });
            resolve();
          });
        });
      });
    },

    async checkIfClubExtrasAvailable(context, clubId = 0) {
      if (clubId > 0) {
        const available = await services.member.clubHasPurchasableExtras(clubId);
        context.commit('setClubExtrasAvailable', available);
      }
    },
  },
};

export { basketStore };
